import React from 'react';

import Layout from 'components/Layout';
import { SNAPASK_SITE_ENDPOINT } from 'config';

import InstructorList from './InstructorList';

async function action(context) {
  const {
    i18n,
    params: { type },
    pathname,
  } = context;

  const { title, description, image } = i18n.t(
    'seo.instructorProfile.allInstructorList',
    {
      returnObjects: true,
    },
  );

  return {
    title,
    description,
    ogTags: {
      title,
      description,
      image,
      type: 'website',
      url: `${SNAPASK_SITE_ENDPOINT}${pathname}`,
    },
    jsonLDList: [
      {
        '@context': 'https://schema.org',
        '@type': 'instructor',
        image,
        name: title,
        description,
        publisher: {
          '@type': 'Organization',
          name: 'Snapask',
        },
      },
    ],
    chunks: ['instructorList'],
    component: (
      <Layout>
        <InstructorList contentType={type} />
      </Layout>
    ),
  };
}

export default action;
